export const GAME_TYPES = [
  {
    id: 1,
    name: 'Troela',
    points: 10,
    cost: 10,
    minPlayers: 2,
    maxPlayers: 2,
    requiresMate: true,
    supportsTricks: true,
    baseTarget: 8,
    description: 'Spelers van het spel troela verdienen 10 punten + 5 punten per overslag'
  },
  {
    id: 2,
    name: 'Rik',
    points: 10,
    cost: 10,
    minPlayers: 2,
    maxPlayers: 2,
    requiresMate: true,
    supportsTricks: true,
    baseTarget: 8,
    description: 'Rikker en maat verdienen 10 punten + 5 punten per overslag'
  },
  {
    id: 3,
    name: 'Betere rik',
    points: 10,
    cost: 10,
    minPlayers: 2,
    maxPlayers: 2,
    requiresMate: true,
    supportsTricks: true,
    baseTarget: 8,
    description: 'Rikker en maat verdienen 10 punten + 5 punten per overslag (harten troef)'
  },
  {
    id: 4,
    name: 'Acht alleen',
    points: 10,
    cost: 10,
    minPlayers: 1,
    maxPlayers: 1,
    requiresMate: false,
    supportsTricks: true,
    baseTarget: 8,
    description: 'Bieder krijgt van elke tegenspeler 10 punten + 5 punten per overslag'
  },
  {
    id: 5,
    name: 'Piek',
    points: 15,
    cost: 15,
    minPlayers: 1,
    maxPlayers: 3,
    requiresMate: false,
    supportsTricks: false,
    supportsThreeState: true,
    baseTarget: 1,
    description: 'Pieker krijgt van elke tegenspeler 15 punten'
  },
  {
    id: 6,
    name: 'Negen alleen',
    points: 20,
    cost: 20,
    minPlayers: 1,
    maxPlayers: 1,
    requiresMate: false,
    supportsTricks: true,
    baseTarget: 9,
    description: 'Bieder krijgt van elke tegenspeler 20 punten + 5 punten per overslag'
  },
  {
    id: 7,
    name: 'Misère',
    points: 25,
    cost: 25,
    minPlayers: 1,
    maxPlayers: 3,
    requiresMate: false,
    supportsTricks: false,
    supportsThreeState: true,
    baseTarget: 0,
    description: 'Bieder krijgt van elke tegenspeler 25 punten'
  },
  {
    id: 8,
    name: 'Tien alleen',
    points: 30,
    cost: 30,
    minPlayers: 1,
    maxPlayers: 1,
    requiresMate: false,
    supportsTricks: true,
    baseTarget: 10,
    description: 'Bieder krijgt van elke tegenspeler 30 punten + 5 punten per overslag'
  },
  {
    id: 9,
    name: 'Open piek',
    points: 40,
    cost: 40,
    minPlayers: 1,
    maxPlayers: 3,
    requiresMate: false,
    supportsTricks: false,
    supportsThreeState: true,
    baseTarget: 1,
    description: 'Pieker krijgt van elke tegenspeler 40 punten'
  },
  {
    id: 10,
    name: 'Elf alleen',
    points: 40,
    cost: 40,
    minPlayers: 1,
    maxPlayers: 1,
    requiresMate: false,
    supportsTricks: true,
    baseTarget: 11,
    description: 'Bieder krijgt van elke tegenspeler 40 punten + 5 punten per overslag'
  },
  {
    id: 11,
    name: 'Open misère',
    points: 50,
    cost: 50,
    minPlayers: 1,
    maxPlayers: 3,
    requiresMate: false,
    supportsTricks: false,
    supportsThreeState: true,
    baseTarget: 0,
    description: 'Bieder krijgt van elke tegenspeler 50 punten'
  },
  {
    id: 12,
    name: 'Open piek met een praatje',
    points: 55,
    cost: 55,
    minPlayers: 1,
    maxPlayers: 3,
    requiresMate: false,
    supportsTricks: false,
    supportsThreeState: true,
    baseTarget: 1,
    description: 'Pieker krijgt van elke tegenspeler 55 punten'
  },
  {
    id: 13,
    name: 'Twaalf alleen',
    points: 50,
    cost: 50,
    minPlayers: 1,
    maxPlayers: 1,
    requiresMate: false,
    supportsTricks: true,
    baseTarget: 12,
    description: 'Bieder krijgt van elke tegenspeler 50 punten + 5 punten voor overslag'
  },
  {
    id: 14,
    name: 'Open misère met een praatje',
    points: 60,
    cost: 60,
    minPlayers: 1,
    maxPlayers: 3,
    requiresMate: false,
    supportsTricks: false,
    supportsThreeState: true,
    baseTarget: 0,
    description: 'Bieder krijgt van elke tegenspeler 60 punten'
  },
  {
    id: 15,
    name: 'Dertien alleen',
    points: 70,
    cost: 70,
    minPlayers: 1,
    maxPlayers: 1,
    requiresMate: false,
    supportsTricks: true,
    baseTarget: 13,
    description: 'Bieder krijgt van elke tegenspeler 70 punten'
  },
  {
    id: 16,
    name: 'Schoppen mie',
    points: 5,
    cost: 5,
    minPlayers: 1,
    maxPlayers: 2,
    requiresMate: false,
    supportsTricks: false,
    baseTarget: 0,
    description: '5 punten per slag voor wie niet de schoppen vrouw of laatste slag haalt'
  },
  {
    id: 17,
    name: 'Één of vijf',
    points: 10,
    cost: 10,
    minPlayers: 1,
    maxPlayers: 4,
    requiresMate: false,
    supportsTricks: false,
    baseTarget: 1,
    description: 'Wie precies 1 of 5 slagen haalt krijgt 10 punten'
  }
];
